import React from 'react'
import styled from 'styled-components'

import Button from '../atoms/Button'
import Heading from '../atoms/Heading'
import Image from '../atoms/Image'
import InstagramFeed from '../molecules/InstagramFeed'
import OuterLink from '../atoms/OuterLink'

const Container = styled.aside`
  margin: 30px 0 0;
  width: 100%;
`

const SubHeading = styled.p`
  align-items: center;
  border-left: 3px solid ${({ theme }) => theme.palette.primary.main};
  color: ${({ theme }) => theme.palette.font.main};
  display: flex;
  font-size: 14px;
  font-weight: bold;
  height: 32px;
  margin: 20px 10px 0;
  padding: 0 0 0 10px;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    align-items: flex-end;
    border: 0;
    border-bottom: 1px solid ${({ theme }) => theme.palette.border.main};
    font-size: 13px;
    margin: 30px 0 0;
    padding: 0;
    line-height: 24px;
  }
`

const SubContainer = styled.div`
  margin: 20px 30px 0;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    margin: 0;
  }
`

const Title = styled.div`
  align-items: center;
  display: flex;
  margin: 20px 0 0;
`

const InstagramIcon = styled(Image)`
  width: 52px;
  height: 52px;
  margin-right: 13px;
  object-fit: cover;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    width: 34px;
    height: 34px;
    margin-right: 8px;
  }
`

const ThemeImage = styled(Image)`
  flex: 1;
`

const Thumbnail = styled.div`
  margin: 10px 0 0;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    margin: 6px 0 0;
  }
`

const LaunchInstagram = styled(OuterLink)`
  display: block;
  margin: 10px auto 0;
  text-decoration: none;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    width: 160px;
  }
`

const LaunchIcon = styled(Image)`
  width: 14px;
  height: 14px;
  margin: 0 0 0 7px;
  object-fit: cover;
`

const Readmore = styled(LaunchInstagram)`
  margin: 12px 30px 0;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    margin: 20px auto 0;
  }
`

export default function InstagramCampaign({ className }: { className?: string }) {
  return (
    <Container className={className}>
      <Heading>お知らせ</Heading>
      <SubHeading>キャンペーン</SubHeading>
      <SubContainer>
        <Title>
          <InstagramIcon alt="Instagramアイコン" filename="instagram.png" />
          <ThemeImage alt="Instagramキャンペーン" filename="instagram-campaign/theme.png" />
        </Title>
        <Thumbnail>
          <Image filename="instagram-campaign/thumb.png" />
        </Thumbnail>
        <LaunchInstagram to="https://www.instagram.com/explore/tags/%E3%83%9E%E3%83%9E%E3%83%AA%E5%8F%A3%E3%82%B3%E3%83%9F%E5%A4%A7%E8%B3%9E/?hl=ja">
          <Button color="pink">
            詳細をみる
            <LaunchIcon alt="Instagramを開く" filename="icon-launch-white.png" />
          </Button>
        </LaunchInstagram>
      </SubContainer>

      <SubHeading>#ママリ口コミ大賞</SubHeading>
      <InstagramFeed />
      <Readmore to="https://www.instagram.com/explore/tags/%E3%83%9E%E3%83%9E%E3%83%AA%E5%8F%A3%E3%82%B3%E3%83%9F%E5%A4%A7%E8%B3%9E">
        <Button color="white">
          もっとみる
          <LaunchIcon filename="icon-launch-pink.png" />
        </Button>
      </Readmore>
    </Container>
  )
}
